resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    GooglePlaces

    Wrapper class for GooglePlaces API, restricted to Canada only

    Ref Src: https://maps.googleapis.com/maps/api/js?key={api_key}&libraries=places
    Type: Script

    callback: function that runs after the scripts.

    inputField: the inputField autocomplete will be attached to
 */

function GooglePlaces (callback, inputField) {
    // Properties
    this._googlePlacesUrl = 'https://maps.googleapis.com/maps/api/js';
  
    if (window.location.host !== "www.mogo.ca") {
      this._googlePlacesAPIKey = 'AIzaSyA8Stw3H2aYC5rb9khu8D1g3BP0KpyelaA'; // Local
    } else {
      this._googlePlacesAPIKey = 'AIzaSyCW7EiZM2Y2EhWuu7Ad9JlTa1ZolBdUvXU'; // Prod
    };
    
    this._googleAutoCompleteObj = null;
  
    // Set initial restrict to canada
    this._googlePlacesOptions = {
      setComponentRestrictions: { country: ['ca'] },
      types: { types: ['address'] }
    };
  
    this._initialized = false;
    this._inputField = inputField;
    this.radiusInMeters = 20000; // Default to 20km or 20000,
  
    if (typeof callback === 'function') this._initiatedCallback = callback;
  
    // Setup Deferred object to be executed sequentially
    // callback functions should run after the script and error listener has been loaded
    this._googlePlacesPromise = $.Deferred();
  
    $.when(this._googlePlacesPromise)
      .done(function () {
        this._setupErrorListener();
      }.bind(this))
      .done(function () {
        this._initAutoComplete();
      }.bind(this));
  
    // The constructor adds the API to the head of the page
    // TODO: use sidecar, dynamically use API keys
    this.constructor = function () {   
      // check for googlePlacesAuthError 
      // mogo.registry.mogoUI.repo.googlePlaces.googlePlacesAuthError used in _initAutoComplete
      if (mogo.registry.mogoUI.repo.googlePlaces === undefined) {
        mogo.registry.mogoUI.repo.googlePlaces = [];
      }
  
      // Get GooglePlaces API
      if (typeof google == 'undefined') {
        mogo.registry.mogoUI.repo.googlePlaces.push(this);
  
        // Load Google Maps API
        $.ajax({
          url: this._googlePlacesUrl,
          data: {
            key: this._googlePlacesAPIKey,
            libraries: 'places'
          },
          dataType: "script",
          async: false,
          success: this._googlePlacesPromise.resolve
        });
      }
    };
  
    this._setupErrorListener = function () {
      // Setup error handling script: programmatically detect an authentication failure
      // If the following global function gm_authFailure is defined it will be called when the authentication fails.
      // When GooglePlaces API errors occur, certain attributes are added to the input field: background, placeholder, disable
      // Enable the address field, remove google's default placeholder text and make the disable background image so it fails gracefully
      var errorListener = "window.gm_authFailure = function () { mogo.registry.mogoUI.repo.googlePlaces.googlePlacesAuthError = true;" +
        "$('.gm-err-autocomplete').prop('disabled', false).prop('placeholder','').css('background-image','none');" +
        "console.warn('auth error');" +
        "};";
  
      // create script element to be put in the head
      var googlePlacesError = document.createElement('script');
      googlePlacesError.type = "text/javascript";
      googlePlacesError.setAttribute('async', 'false');
      googlePlacesError.text = errorListener;
  
      $("head").append(googlePlacesError);
  
      this._googlePlacesPromise.resolve();
    };
  
    this._initAutoComplete = function () {
      if (!mogo.registry.mogoUI.repo.googlePlaces.googlePlacesAuthError && google !== 'undefined') {
        this._initialized = true;
  
        // AutoComplete is attached to the address input field,
        // NOTE: placeholder set to "" to override google maps API default placeholder
        var autoCompleteInputField = this._inputField;
        this._inputField.placeholder = '';
        this._googleAutoCompleteObj = new google.maps.places.Autocomplete(autoCompleteInputField, this._googlePlacesOptions.types);
  
        // Bias the autocomplete object to the user's geographical location,
        // as supplied by the browser's 'navigator.geolocation' object.
        this._setBounds();
        this._setComponentRestrictions();
        this._addListener();
      };
    };
  
    // Set initial restrict to the greater list of countries.
    this._setComponentRestrictions = function () {
      this._googleAutoCompleteObj.setComponentRestrictions(this._googlePlacesOptions.setComponentRestrictions);
    };
  
    // place_changed: handlers the event when the user selects an address from the dropdown.
    // using this listener callback function to return autocomplete data.
    this._addListener = function () {
      this._googleAutoCompleteObj.addListener('place_changed', function () {
        // Get the place details from the autocomplete object.
        // Autocomplete creates a text input field on your web page, 
        // supplies predictions of places in a UI pick list, and returns place details in response to a getPlace() request.
        // Each entry in the pick list corresponds to a single place (as defined by the Places SDK).
        var autoCompleteObj = this._googleAutoCompleteObj.getPlace();
        var streetAddress = autoCompleteObj.name;
  
        // Organize autocomplete data
        var address = {
          name: streetAddress
        };
  
        for (var i = 0; i < autoCompleteObj.address_components.length; i++) {
          var addressType = autoCompleteObj.address_components[i].types[0];
          switch (addressType) {
            case 'locality':
              address.city = autoCompleteObj.address_components[i].long_name;
              break;
            case 'administrative_area_level_1':
              address.state = autoCompleteObj.address_components[i].short_name;
              break;
            case 'postal_code':
              address.postal_code = autoCompleteObj.address_components[i].short_name;
              break;
            default:
              // sometimes obj doesn't return values with types. For this case, do nothing
              break;
          }
        }
  
        // return data back to callback argument
        if (this._initiatedCallback !== null) this._initiatedCallback(address);
      }.bind(this));
    };
  
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    // radius is in meters
    this._setBounds = function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
  
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: this.radiusInMeters
          });
  
          this._googleAutoCompleteObj.setBounds(circle.getBounds());
        }.bind(this));
      }
    };
  
    this.constructor();
  }
  